import { ICommand } from 'core-ts-types';
import { FeedbackSuggestedPlanModel } from '../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { myPlanState, planResolve } from '../ap_plan_routes';
import { LoadProgramAndTermsDataCommand } from './../../suggestions/commands/load_program_and_terms_data_command';
import { ReRouteAdvisorPlanAccessCommand } from './../re_route_strategies/re_route_advisor_plan_access_command';
import { APAdvisorAlternatePlanRoutes } from './ap_advisor_alternate_plans_routes';
import { ApAdvisorFlagCourseDetailRoutes } from './planner/ap_advisor_flag_course_popup_routes';
import { ApAdvisorLockCourseDetailRoutes } from './planner/ap_advisor_lock_course_popup_routes';
import { ApAdvisorMarkAsMetRoutes } from './planner/ap_advisor_mark_as_met_popup_routes';
import { ApStudentDetailsModel } from './../../global/components/student_details/models/ap_student_details_model';
import { AdvisorPlannerEditRoutes } from './planner/ap_advisor_planner_edit_routes';
import { AdvisorPlannerViewRoutes } from './planner/ap_advisor_planner_view_routes';
import { AdvisorSuggestionBlockedStateRoutes } from './planner/ap_advisor_suggestion_blocked_state_routes';

export const ApPlanAdvisorRoutes = {
  'ap-advisor': {
    url: 'advisor/',
    sticky: true,
    template: `
      <div class="ap-advisor-module">
        <busy-indicator></busy-indicator>
        <ui-view></ui-view>
        <ui-view name='modal'></ui-view>
      </div>`,
    resolve: {
      setupUser: (setupUserCommand: ICommand) => setupUserCommand()
    }
  },
  'ap-advisor.student-plan-progress': <ng.ui.IState>{
    url: 'student-plan-progress/',
    data: {
      pageTitle: 'Student progressing with plan'
    },
    template: `<student-plan-progress></student-plan-progress>`,
    resolve: {
      allowToProceed: (navigateIfPlanBlockedCommand: ICommand) => navigateIfPlanBlockedCommand(),
      termsAndProgram: (loadProgramAndTermsDataCommand: LoadProgramAndTermsDataCommand) =>
        loadProgramAndTermsDataCommand(),
      feedbackPlan: (loadPlanFeedbackCommand: ICommand) => loadPlanFeedbackCommand(),
      flaggedCourses: (loadCommentCommand: ICommand, ngApStudentDetailsModel: ApStudentDetailsModel) =>
        loadCommentCommand(`academicplan/student_comments/`)
    }
  },
  'ap-advisor.no-plan': {
    data: {
      pageTitle: 'No plan configured'
    },
    template: '<advisor-student-no-plan-configured></advisor-student-no-plan-configured>'
  },
  'ap-advisor.plan': {
    ...myPlanState,
    views: {
      '': {
        template: `<ui-view></ui-view>`
      }
    },
    data: {
      pageTitle: 'My Planner'
    },
    resolve: {
      ...planResolve,
      academicPlan: () => true,
      studentNk: () => window.sessionStorage.getItem('external_id'),
      studentDetails: (loadAdvisorStudentDetailsCommand: ICommand, studentNk: string) =>
        loadAdvisorStudentDetailsCommand(studentNk),
      studentValue: (loadStudentValueCommand: ICommand) => loadStudentValueCommand(),
      userActivityInitialize: (
        initializeUserActivityTrackingCommand: ICommand,
        studentDetails: ng.IPromise<any>,
        accountIdentity: ng.IPromise<any>
      ) => initializeUserActivityTrackingCommand(),
      suggestedPlanStatus: (
        loadSuggestedPlanStatusCommand: ICommand,
        ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
      ) => {
        return loadSuggestedPlanStatusCommand().catch((er: any) => {
          if (er.status === 400) {
            ngFeedbackSuggestedPlanModel.clear();
            return true;
          }
          return false;
        });
      }
    },
    onEnter: (suggestedPlanStatus: any, reRouteAdvisorPlanAccessCommand: ReRouteAdvisorPlanAccessCommand) =>
      reRouteAdvisorPlanAccessCommand()
  },
  ...AdvisorSuggestionBlockedStateRoutes,
  ...AdvisorPlannerViewRoutes,
  ...AdvisorPlannerEditRoutes,
  ...ApAdvisorFlagCourseDetailRoutes,
  ...ApAdvisorLockCourseDetailRoutes,
  ...APAdvisorAlternatePlanRoutes,
  ...ApAdvisorMarkAsMetRoutes
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/advisor_routes/ap_advisor_plan_routes.ts